import { HashRouter,Routes, Route } from 'react-router-dom';
import  {useEffect,useState} from "react";
import Dashboard from './pages/Dashboard';
 import ErrorBoundary from './components/ErrorBoundary';
import Races from './pages/race/Races';
import Topups from './pages/topup/Topups';
import Withdrawals from './pages/withdraw/Withdrawals';
import Login from './pages/Login';
import axios from 'axios';
import { API_URL} from "./components/constants";
import { useUserContext } from './components/UserContext';

function App(){
    const [msisdn, setMsisdn] = useState('');
    const [minBal, setMinBal] = useState(0);
    const [bal, setBal] = useState(0);
    const {setDefaultMinBal,setDefaultRace,  setDefaultBal } = useUserContext();
    useEffect(  () =>{
        (
         async () => {
            try {
                const {data} = await axios.get(`${API_URL}/appUser`);
                //const {data} = await axios.get(`${API_URL}/user`);
               //console.log(data);
                setMsisdn(data.msisdn);
                setMinBal(data.MinBal);
                setBal(data.bal);
                setDefaultBal(data.bal);
                setDefaultMinBal(data.MinBal);
                setDefaultRace(data.current_race);
            } catch (error) {
                console.log("First load error code 0780");
                
            }
            
         }
        )();
      }, []);
     return (
         <ErrorBoundary>
             <HashRouter>
                 <Routes>
                    
                    <Route path="/" element={<Dashboard msisdn={msisdn} bal={bal} minBal={minBal} />}/>
                    <Route path="/race" element={<Races msisdn={msisdn}  bal={bal} minBal={minBal} />}/>
                    <Route path="/topup" element={<Topups msisdn={msisdn}  bal={bal} minBal={minBal} />}/>
                    <Route path="/withdraw" element={<Withdrawals msisdn={msisdn}  bal={bal} minBal={minBal} />}/>
                    <Route path="/login" element={<Login/>}/>
                  
                     
                </Routes>
             </HashRouter>
        </ErrorBoundary>
    );
}
export default App;